import { render, staticRenderFns } from "./colorSlider.vue?vue&type=template&id=4596f5f4"
import script from "./colorSlider.vue?vue&type=script&lang=js"
export * from "./colorSlider.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports